// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"5282e72f","232":"8dc6a1ee","237":"dba4a53d","357":"53cedfe8","526":"c9bbfdec","753":"77946a85","787":"108474f6","854":"914dbd7c","872":"a9657112"}[chunkId] + ".chunk.js";
};